exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".screen-settings{padding-bottom:16px}.screen-settings .select{margin-top:16px}", ""]);

